import { IoClose, IoCopy } from "react-icons/io5";
import {
    FaWhatsapp,
    FaInstagram,
    FaFacebook,
    FaTwitter,
    FaEnvelope,
    FaLink,
    FaQrcode
} from "react-icons/fa";
import { handleCopy } from "../../../helpers";

const ShareModal = ({ isOpen, onClose, shareData }) => {
    if (!isOpen) return null;

    const shareLink = shareData?.link; // or from props

    const copyLink = () => {
        handleCopy(shareLink);
    };

    const shareOnWhatsApp = () => {
        const text = encodeURIComponent("Check this out!");
        window.open(`https://wa.me/?text=${text} ${encodeURIComponent(shareLink)}`, '_blank');
    };

    const shareOnInstagram = () => {
        // Instagram doesn't have a direct share URL, so copy link and notify
        handleCopy(shareLink);
    };

    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`, '_blank');
    };

    const shareOnTwitter = () => {
        const text = encodeURIComponent("Check this out!");
        window.open(`https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(shareLink)}`, '_blank');
    };

    const shareOnEmail = () => {
        const subject = encodeURIComponent("Check this out!");
        const body = encodeURIComponent(`I thought you might find this interesting:\n\n${shareLink}`);
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md relative animate-fadeIn">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
                >
                    <IoClose size={22} />
                </button>

                <div className="p-6">
                    <h2 className="text-xl font-semibold text-gray-900">
                        Share
                    </h2>

                    <p className="text-gray-600 text-sm mt-1">
                        Share this listing with your friends and family
                    </p>

                    {/* Social Share Buttons */}
                    <div className="grid grid-cols-4 gap-4 my-6">
                        <button
                            onClick={shareOnWhatsApp}
                            className="flex flex-col items-center gap-2 p-3 hover:bg-gray-100 rounded-xl transition"
                        >
                            <FaWhatsapp className="w-6 h-6 text-green-500" />
                            <span className="text-xs">WhatsApp</span>
                        </button>
                        <button
                            onClick={shareOnInstagram}
                            className="flex flex-col items-center gap-2 p-3 hover:bg-gray-100 rounded-xl transition"
                        >
                            <FaInstagram className="w-6 h-6 text-pink-600" />
                            <span className="text-xs">Instagram</span>
                        </button>
                        <button
                            onClick={shareOnFacebook}
                            className="flex flex-col items-center gap-2 p-3 hover:bg-gray-100 rounded-xl transition"
                        >
                            <FaFacebook className="w-6 h-6 text-blue-600" />
                            <span className="text-xs">Facebook</span>
                        </button>
                        <button
                            onClick={shareOnTwitter}
                            className="flex flex-col items-center gap-2 p-3 hover:bg-gray-100 rounded-xl transition"
                        >
                            <FaTwitter className="w-6 h-6 text-blue-400" />
                            <span className="text-xs">Twitter</span>
                        </button>
                        <button
                            onClick={shareOnEmail}
                            className="flex flex-col items-center gap-2 p-3 hover:bg-gray-100 rounded-xl transition"
                        >
                            <FaEnvelope className="w-6 h-6 text-gray-600" />
                            <span className="text-xs">Email</span>
                        </button>
                        <button
                            onClick={copyLink}
                            className="flex flex-col items-center gap-2 p-3 hover:bg-gray-100 rounded-xl transition"
                        >
                            <FaLink className="w-6 h-6 text-gray-600" />
                            <span className="text-xs">Copy link</span>
                        </button>
                    </div>

                    {/* Link Display */}
                    <div className="border rounded-lg px-3 py-2 bg-gray-50 flex items-center justify-between gap-3">
                        <p className="text-gray-700 text-sm truncate">{shareLink}</p>
                        <button
                            onClick={copyLink}
                            className="p-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition"
                        >
                            <IoCopy size={18} className="text-gray-700" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareModal;